import { ICallSlot } from '../types';

const MOSCOW_TIME_ZONE = 'Europe/Moscow';
const MS_IN_DAY = 24 * 60 * 60 * 1000;

const timeFormatter = new Intl.DateTimeFormat('ru-RU', {
  timeZone: MOSCOW_TIME_ZONE,
  hour: '2-digit',
  minute: '2-digit',
});

const dayFormatter = new Intl.DateTimeFormat('ru-RU', {
  timeZone: MOSCOW_TIME_ZONE,
  day: 'numeric',
  month: 'long',
});

/* Календарная дата в московской зоне: en-CA даёт готовый YYYY-MM-DD, который можно сравнивать
   строками и вычитать как дни */
const isoDayFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: MOSCOW_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const toMoscowDay = (date: Date): string => isoDayFormatter.format(date);

const daysBetween = (from: string, to: string): number =>
  Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / MS_IN_DAY);

interface IFormatCallSlotTitleOptions {
  callSlot: ICallSlot;
  now?: Date;
}

export const formatCallSlotTitle = ({ callSlot, now = new Date() }: IFormatCallSlotTitleOptions): string => {
  const start = new Date(callSlot.slotStart);
  const end = new Date(callSlot.slotEnd);
  const offsetInDays = daysBetween(toMoscowDay(now), toMoscowDay(start));

  const day = offsetInDays === 0 ? 'сегодня' : offsetInDays === 1 ? 'завтра' : dayFormatter.format(start);

  return `Свяжемся ${day}, с ${timeFormatter.format(start)} до ${timeFormatter.format(end)}`;
};
